import { Button, Dialog, DialogTitle, Grid } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { AppContext } from "../../contexts/AppContext";
import WelcomeDetails from "./WelcomeDetails";
import { setStyle } from "../../util";
import Layout from "../Layout";
import Signup from "./Authentication/Signup";
import { useNavigate } from "react-router-dom";

const Welcome = () => {
    const { defaultValues } = useContext(AppContext);
    const { server, setServer, socket } = useContext(AppContext);
    const navigate = useNavigate()

    useEffect(() => {
        if (defaultValues) { setStyle(defaultValues); }
    })


    return (
        <Layout>
    
                    <Main>
                        <TopSubdivision>
                            <WelcomeDetails />
                        </TopSubdivision>
                        {/*
                        <ServerSelector selectedServer={server} setSelectedServer={setServer} />
                        <Text>Serveur sélectionné: <i>{server}</i></Text>
                        
                        <BottomSubdivision>
                        */}
                        <Grid className="container-btn" container justifyContent='flex-start' alignContent='center' xs={12} sm={12} md={6} lg={6} xl={6}>
                            <Button className="serious-btn" variant="contained" onClick={()=>{navigate('/register');}}>
                                S’inscrire
                            </Button>
                            <Button className="serious-btn" variant="contained" onClick={()=>{navigate('/login');}}>
                                Se connecter
                            </Button>
                        </Grid>
                        {/*    
                        </BottomSubdivision>
                        
                        <Dialog open={open} onClose={handleClose}>
                            <DialogTitle>Serveur <i>{server}</i></DialogTitle>
                            <Authentication />
                        </Dialog>
                        
                        <Signup />*/}
                    </Main>
   
        </Layout>

    );
};

const Container = styled.div`
    display: flex;
    padding: 1em;
    border-radius: 5px;
`


const Main = styled.div`
    display: flex;
    flex-direction: column;
    padding: 2em;
    align-self: center;
`

const TopSubdivision = styled.div`
    display: flex;
`

const BottomSubdivision = styled.div`
    margin: auto;
    margin-top: 1em;
`


export default Welcome;